import axios from '@/axios'

export default {
  getAll() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getAllByOrganisation(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/organisation/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getById(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/users/${id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  update(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  adminUpdate(item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/users/admin`, item)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  adminUpdatePassword(id, password) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/users/admin/update-password`, {
          id: id,
          password: password
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  updatePassword(password) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/users/update-password`, {
          password: password
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
